"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ioTsStrMapInterpreter = void 0;
var utils_1 = require("@morphic-ts/common/lib/utils");
var function_1 = require("fp-ts/function");
var t = require("io-ts");
var config_1 = require("../config");
var hkt_1 = require("../hkt");
/**
 *  @since 0.0.1
 */
exports.ioTsStrMapInterpreter = utils_1.memo(function () { return ({
    _F: hkt_1.IoTsURI,
    strMap: function (codomain, config) { return function (env) {
        return function_1.pipe(codomain(env).type, function (type) { return new hkt_1.IOTSType(config_1.iotsApplyConfig(config)(t.record(t.string, type), env, { type: type })); });
    }; },
    record: function (domain, codomain, config) { return function (env) {
        return (function (domainType, codomainType) {
            return new hkt_1.IOTSType(config_1.iotsApplyConfig(config)(t.record(domainType, codomainType), env, { domainType: domainType, codomainType: codomainType }));
        })(domain(env).type, codomain(env).type);
    }; }
}); });
